import Repository from '../axios'
import {defaultPagination} from "@/constants/config";
import staff from "../apis/staff";

const  resource = "/admin/staff";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getStaff(staffId){
    return Repository.get(`${resource}/${staffId}`)
  },
  createStaff(payload){
    return Repository.post(`${resource}`, payload)
  },
  updateStaff(staff_id, payload){
    return Repository.put(`${resource}/${staff_id}`, payload)
  },
  accountVerify(code) {
    return Repository.get(`/admin/staff/verify/${code}`)
  },
  forgotPassword(payload) {
    return Repository.post(`admin/forgot-password`, payload)
  },
  getForgotPasswordToken(token){
    return Repository.get(`admin/forgot-password/${token}`)
  },
  passwordReset(payload){
    return Repository.post(`admin/reset-password`, payload)
  },
  passwordChange(payload){
    return Repository.put(`/admin/staff/change-password`, payload)
  },
  getCurrencyList(){
    return Repository.get(`admin/system_setting/currencies`)
  },
  resendWelcomeEmail(email) {
    return Repository.put(`/admin/${email}/staff-resend`)
  },
  deActiveStaffUser(id) {
    return Repository.put(`/admin/staff/${id}/de-activate`)
  },
  activeStaffUser(id) {
    return Repository.put(`/admin/staff/${id}/activate`)
  },
  storeStaffPassword(payload) {
    return Repository.put(`/admin/staff/store-password`, payload)
  },

  // 2fa
  get2FAQRCode(staff_id) {
    return Repository.get(`/admin/2fa/${staff_id}/show-2fa-code`)
  },
  enable2FA(payload, staff_id) {
    return Repository.put(`/admin/2fa/${staff_id}/enable-2fa`, payload)
  },
  disable2FA(payload, staff_id) {
    return Repository.put(`/admin/2fa/${staff_id}/disable-2fa`, payload)
  },

  uploadProfileImage(auth_id, payload) {
    return Repository.put(`/admin/staff/${auth_id}/avatar`, payload)
  },

  //notifications
  getListOfNotifications(staff_id) {
    return Repository.get(`${resource}/notifications-list`)
  },
  disabledNotification(payload) {
    return Repository.put(`${resource}/disable-notifications`, payload)
  },

  updateEmail(staff_id, payload) {
    return Repository.put(`${resource}/${staff_id}/update-email`, payload)
  },

  confirmEmailChange(payload) {
    return Repository.put(`${resource}/confirm-email-change`, payload)
  },

  //support app 
  fetchSupportAppToken() {
    return Repository.post('/admin/support/sso/generate-token')
  },

  //mobile app pin
  viewMobileAppPin(payload) {
    return Repository.post('/admin/mobile-app/pin/view', payload)
  },
  updateMobileAppPin(payload) {
    return Repository.put('/admin/mobile-app/pin', payload)
  }
};

